// Loading skeletons for the My Rentals page (list) and My Rentals Detail page

export function MyRentalsSkeleton() {
    return (
        <>
            {/* Desktop Table Skeleton */}
            <div className="hidden md:block bg-white dark:bg-[#1A1A1A] rounded-2xl border border-[#E5E7EB] dark:border-[#2A2A2A] shadow-sm overflow-hidden">
                <table className="w-full text-left min-w-[900px]">
                    <thead>
                        <tr className="bg-[#F9FAFB] dark:bg-[#0F0F0F] border-b border-[#E5E7EB] dark:border-[#2A2A2A]">
                            {["Invoice ID", "No. of Items", "Dates", "Total", "Status", "Actions"].map((h) => (
                                <th key={h} className="px-6 py-4 text-xs font-bold text-[#666666] dark:text-[#A0A0A0] uppercase tracking-wider">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-[#F0F0F0] dark:divide-[#2A2A2A]">
                        {[1, 2, 3, 4, 5].map((row) => (
                            <tr key={row} className="animate-pulse">
                                <td className="px-6 py-4"><div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-28"></div></td>
                                <td className="px-6 py-4"><div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-16"></div></td>
                                <td className="px-6 py-4">
                                    <div className="h-3 bg-gray-200 dark:bg-[#262626] rounded w-20 mb-1.5"></div>
                                    <div className="h-3 bg-gray-100 dark:bg-[#333333] rounded w-20"></div>
                                </td>
                                <td className="px-6 py-4"><div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-20"></div></td>
                                <td className="px-6 py-4"><div className="h-6 bg-gray-200 dark:bg-[#262626] rounded-full w-20"></div></td>
                                <td className="px-6 py-4">
                                    <div className="flex gap-2">
                                        <div className="w-7 h-7 bg-gray-200 dark:bg-[#262626] rounded-lg"></div>
                                        <div className="w-7 h-7 bg-gray-200 dark:bg-[#262626] rounded-lg"></div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Mobile Card Skeletons */}
            <div className="md:hidden space-y-4">
                {[1, 2, 3].map((card) => (
                    <div key={card} className="bg-white dark:bg-[#1A1A1A] p-5 rounded-2xl border border-[#E5E7EB] dark:border-[#2A2A2A] shadow-sm space-y-4 animate-pulse">
                        <div className="flex items-start justify-between">
                            <div className="space-y-2">
                                <div className="h-3 bg-gray-200 dark:bg-[#262626] rounded w-24"></div>
                                <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-16"></div>
                            </div>
                            <div className="h-6 bg-gray-200 dark:bg-[#262626] rounded-full w-20"></div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <div className="space-y-1.5">
                                <div className="h-2.5 bg-gray-100 dark:bg-[#333333] rounded w-12"></div>
                                <div className="h-3.5 bg-gray-200 dark:bg-[#262626] rounded w-20"></div>
                            </div>
                            <div className="space-y-1.5">
                                <div className="h-2.5 bg-gray-100 dark:bg-[#333333] rounded w-12"></div>
                                <div className="h-3.5 bg-gray-200 dark:bg-[#262626] rounded w-20"></div>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <div className="h-10 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                            <div className="h-10 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}

export function MyRentalsDetailSkeleton() {
    return (
        <div className="p-4 md:p-8 lg:p-10 max-w-[1400px] mx-auto space-y-6 animate-pulse">
            {/* Header bar */}
            <div className="flex items-center gap-4">
                <div className="w-10 h-10 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                <div className="space-y-2 flex-1">
                    <div className="h-5 bg-gray-200 dark:bg-[#262626] rounded w-48"></div>
                    <div className="h-3 bg-gray-100 dark:bg-[#333333] rounded w-32"></div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* PDF iframe area */}
                <div className="lg:col-span-2 bg-white dark:bg-[#1A1A1A] rounded-2xl border border-[#E5E7EB] dark:border-[#2A2A2A] overflow-hidden">
                    <div className="h-[600px] bg-gray-100 dark:bg-[#0A0A0A]"></div>
                </div>

                {/* Sidebar info cards */}
                <div className="space-y-4">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="bg-white dark:bg-[#1A1A1A] p-5 rounded-2xl border border-[#E5E7EB] dark:border-[#2A2A2A] space-y-3">
                            <div className="h-3 bg-gray-100 dark:bg-[#333333] rounded w-20"></div>
                            <div className="h-5 bg-gray-200 dark:bg-[#262626] rounded w-32"></div>
                        </div>
                    ))}
                    {/* Action buttons */}
                    <div className="flex gap-3">
                        <div className="flex-1 h-11 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                        <div className="flex-1 h-11 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
